import Vue from 'vue'
import VueHighlightJS from 'vue-highlightjs'
// import 'prismjs/themes/prism-okaidia.min.css'

Vue.use(VueHighlightJS)